import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#041952",
  "fill-rule": "evenodd",
  d: "M4.792 4.167c0-.576.466-1.042 1.041-1.042h8.334c.575 0 1.041.466 1.041 1.042V5a.625.625 0 1 0 1.25 0v-.833a2.29 2.29 0 0 0-2.291-2.292H5.833a2.29 2.29 0 0 0-2.291 2.292v11.666a2.29 2.29 0 0 0 2.291 2.292h8.334a2.29 2.29 0 0 0 2.291-2.292V15a.625.625 0 1 0-1.25 0v.833c0 .576-.466 1.042-1.041 1.042H5.833a1.04 1.04 0 0 1-1.041-1.042zm8.983 8.775 2.5-2.5a.625.625 0 0 0 0-.884l-2.5-2.5a.625.625 0 0 0-.884.884l1.433 1.433H10a.625.625 0 1 0 0 1.25h4.324l-1.433 1.433a.625.625 0 0 0 .884.884",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }